import { render, staticRenderFns } from "./TheFailedSendsPanel.vue?vue&type=template&id=6d8f0d1d&scoped=true"
import script from "./TheFailedSendsPanel.vue?vue&type=script&lang=js"
export * from "./TheFailedSendsPanel.vue?vue&type=script&lang=js"
import style0 from "./TheFailedSendsPanel.vue?vue&type=style&index=0&id=6d8f0d1d&prod&lang=scss"
import style1 from "./TheFailedSendsPanel.vue?vue&type=style&index=1&id=6d8f0d1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8f0d1d",
  null
  
)

export default component.exports